import { Box, Button, Container, Typography } from '@mui/material';
import React from 'react';
import Logo from './components/Logo';
import { unescape } from 'lodash';

const colors = { primary: '#345784' };

export default function ForgotPasswordSuccess({ email, navTo }) {
  const unescapedEmail = unescape(email);
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Logo />
      <Container sx={{ maxWidth: 428, textAlign: 'center' }}>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            mb: 4,
            color: colors.primary,
          }}
        >
          Password Reset
        </Typography>
        <Typography sx={{ mb: 4 }}>
          Your request has been received. If {unescapedEmail} is associated with a registered
          account, we will send an email with instructions for resetting your password.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navTo('login')}
          sx={{ backgroundColor: colors.primary }}
        >
          Login
        </Button>
      </Container>
    </Box>
  );
}
